import React from 'react';

const Splash = () => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-secondary-500 z-50">
      <div className="w-48 h-1 bg-white/20 rounded-full overflow-hidden">
        <div className="h-full bg-white rounded-full animate-loading-bar" />
      </div>
    </div>
  );
};

export default Splash; 
